export type Locale = 'en-US' | 'fr-CA' | 'en-CA'
export const SUPPORTED_LANGUAGES = ['en-US', 'fr-CA', 'en-CA']
